export const councilNameFormatted = {
  MEDICO: 'Medicina',
  NUTRICIONISTA: 'Nutrição',
  ENFERMEIRO: 'Enfermagem',
  PSICOLOGO: 'Psicologia',
  ASSISTENTE_SOCIAL: 'Serviço social',
  DENTISTA: 'Odontologia',
  FISIOTERAPEUTA: 'Fisioterapia',
  FONOAUDIOLOGO: 'Fonoaudiologia',
  EDUCADOR_FISICO: 'Educação física',
}

export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000
